// Icon fonts
require('./styles/fonts/vrm-weather-icons/vrm-weather-icons.font');
require('./styles/fonts/vrm-icons/vrm-icons.font');

// See dist/config.js

/**
 * Configuration of the VRM application
 * @typedef {Object} VrmConfig
 * @property {boolean} locationHtml5Mode - Whether the router is in history mode or uses hash notation
 * @property {string} api - Base-url for all api calls
 * @property {string} apiDomain - The domain the api calls are directed under
 * @property {string} localStoragePrefix - The prefix to use for all localStorage access
 * @property {string} reportUrl - The url to download installation overview reports from
 * @property {string} reportApiDomain - The domain of the reportUrl
 * @property {boolean} enableMQTT - Enables MQTT communication
 * @property {boolean} enableRealtime - MQTT setting
 * @property {string} mqttHost - MQTT setting
 * @property {string} mqttHostRealtime - MQTT setting
 * @property {number} mqttPort - MQTT setting
 * @property {string} mqttApiEnvironment - MQTT setting
 * @property {boolean} showGlobalMessage - Whether it should be shown or not
 * @property {string} globalMessageType - Message type (one of: "info" (blue), "error" (red), Default: error)
 * @property {string} globalMessage - Message to be shown
 * @property {boolean} debug - Whether the app is in debug mode
 * @property {boolean} debugInfoEnabled - Enables the $compileProvider to insert debug information about templates into the DOM
 * @property {boolean} sentryEnabled
 * @property {boolean} sentry
 * @property {boolean} dynamicEssPromotionEnabled
 * @property {boolean} loadSheddingEnabled
 * @property {string} googleMapsApiKey - The api-key for googlemaps api usage
 * @property {string} mapboxApiKey
 * @property {string} mapboxBaseStyleLight
 * @property {string} recaptchaKey
 * @property {string} firebase.apiKey - The Firebase Web API Key for communicating with the firebase notifications api
 * @property {string} firebase.authDomain
 * @property {string} firebase.projectId
 * @property {string} firebase.storageBucket
 * @property {string} firebase.measurementId
 * @property {string} firebase.appId
 * @property {string} firebase.messagingSenderId - The Firebase sender id for notifications
 * @property {boolean} christmasModeEnabled - Enables christmas mode
 * @property {boolean} easterModeEnabled
 * @property {boolean} easterAnimationsEnabled
 * @property {boolean} summerModeEnabled
 * @property {boolean} summerAnimationsEnabled
 * @property {number} mobileInstallationOverviewDetailThreshold
 * @property {number} notificationLifespan
 * @property {number} refreshInstallationsInterval - The interval in milliseconds to refresh the installations list
 * @property {boolean} autoLoadStateWidgets - Whether state widgets should be loaded automatically (no clicking on the button)
 * @property {boolean} whatsNewEnabled
 * @property {boolean} newFeaturesBannerEnabled - Whether new features banner should be shown to the user or not
 */

/** @type {VrmConfig} */
export const vrmConfig = window.__config;
